// Source: https://gist.github.com/excalq/2961415#gistcomment-1707533
function updateQueryStringParam(key, value) {
  var baseUrl = [location.protocol, '//', location.host, location.pathname].join(''),
    urlQueryString = document.location.search,
    newParam = key + '=' + value,
    params = '?' + newParam;

  // If the "search" string exists, then build params from it
  if (urlQueryString) {
    var keyRegex = new RegExp('([\?&])' + key + '[^&]*');

    // If param exists already, update it
    if (urlQueryString.match(keyRegex) !== null) {
      params = urlQueryString.replace(keyRegex, "$1" + newParam);
    } else { // Otherwise, add it to end of query string
      params = urlQueryString + '&' + newParam;
    }
  }
  window.history.replaceState({}, "", baseUrl + params);
};

function updateLinkQueryStringParam(css_finder, key, value) {
  var link = $(css_finder)[0],
    urlQueryString = link.href,
    newParam = key + '=' + value,
    params = '?' + newParam;

  // If the "search" string exists, then build params from it
  if (urlQueryString) {
    var keyRegex = new RegExp('([\?&])' + key + '[^&]*'),
      newUrl = '';

    // If param exists already, update it
    if (urlQueryString.match(keyRegex) !== null) {
      newUrl = urlQueryString.replace(keyRegex, "$1" + newParam);
    } else { // Otherwise, add it to end of query string
      newUrl = urlQueryString + '?' + newParam;
    }
  }
  link.href = newUrl;
}

export {
  updateQueryStringParam,
  updateLinkQueryStringParam
}
